import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TInputs = {
  lastModifiedFrom: string;
  lastModifiedTo: string;
};

const defaultValues: TInputs = {
  lastModifiedFrom: '',
  lastModifiedTo: '',
};

export const LastModifiedFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  useEffect(() => {
    if (params.lastModifiedFrom || params.lastModifiedTo) setIsActive.on();
    else setIsActive.off();
  }, [params.lastModifiedFrom, params.lastModifiedTo]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  const updateValues = () => {
    setValue('lastModifiedFrom', (params?.lastModifiedFrom as string) ?? '');
    setValue('lastModifiedTo', (params?.lastModifiedTo as string) ?? '');
  };

  useEffect(() => {
    updateValues();
  }, [params.lastModifiedFrom, params.lastModifiedTo]);

  const onSubmit = (data: TInputs) => {
    params.lastModifiedFrom = data.lastModifiedFrom;
    params.lastModifiedTo = data.lastModifiedTo;
    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => (Object.keys(formState.dirtyFields).length ? false : true);

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='lastModifiedFrom'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Last Modified From</FormLabel>
                <Input type='date' onChange={onChange} size='sm' onBlur={onBlur} value={value} name={name} />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name='lastModifiedTo'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Last Modified To</FormLabel>
                <Input type='date' onChange={onChange} size='sm' onBlur={onBlur} value={value} name={name} />
              </FormControl>
            )}
          />
          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
